import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { PrepaidDuty } from './constants';
import DutiesAndTaxesDropdown from './dropdown';
import { dutiesAndTaxesMessages } from './messages';
import HelpArticleLink from '../../components/help-article-link';
import { linkIDs } from '../../services/link-service/links';
import { useFulfillmentPlannerContext } from '../context';

import style from './style.module.less';

const findPrepaidDutyOption = ({ additionalOptionEnum }) => additionalOptionEnum === PrepaidDuty;

const DutiesAndTaxes = ({ id, dropdownMenuType, className = null, showBanner = false }) => {
  const { availableDutiesOptions, onSelectedDutyOptionChange, otherShippingOptions } = useFulfillmentPlannerContext();

  const selectedOption = useMemo(() => {
    const additionalOptions = otherShippingOptions?.additionalOptions || [];
    return additionalOptions.find(findPrepaidDutyOption);
  }, [otherShippingOptions]);
  const onChange = useCallback(
    (value) => {
      onSelectedDutyOptionChange(value, availableDutiesOptions);
    },
    [availableDutiesOptions, onSelectedDutyOptionChange],
  );
  return (
    <>
      <div className={className}>
        <DutiesAndTaxesDropdown
          dropdownMenuType={dropdownMenuType}
          id={id}
          onChange={onChange}
          selectedOptionValue={selectedOption?.additionalOptionValue.prepaidDuty}
        />
      </div>
      {showBanner && (
        <InlineMessage className={style['duties-and-taxes__inline-message']} type={INLINE_MESSAGE_TYPES.info}>
          <FormattedMessage
            {...dutiesAndTaxesMessages.learnMoreLinkMessage}
            values={{
              a: (chunks) => <HelpArticleLink articleId={linkIDs.InternationalDutiesBilling}>{chunks}</HelpArticleLink>,
            }}
          />
        </InlineMessage>
      )}
    </>
  );
};

DutiesAndTaxes.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  className: PropTypes.string,
  showBanner: PropTypes.bool,
};

export default DutiesAndTaxes;
